/** Defines a base structure for items that are not part of collections */
export default class ItemSkeletton {
  public data: any;

  public constructor() {
    this.data = {
      attributes: {},
    };
  }
}
